import { ArrowSmallRightIcon } from '@heroicons/react/20/solid'
import One from '../images/one.png'
import Two from '../images/Two.jpg'
import Three from '../images/three.jpg'
import Four from '../images/four.jpg'
import Five from '../images/five.jpeg'

export default function Example() {
  return (
    <div id='actions' className="relative isolate overflow-hidden text-start bg-white px-6 py-4 sm:py-8 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        {/* <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
        </svg> */}
        <div
          className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#facc15] to-[#0284c7] opacity-20"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div
          className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#facc15] to-[#0284c7] opacity-20"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-2">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-sky-600">Core program</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Social assistance Program</h1>
              <p className="mt-4 text-xl leading-8 text-gray-700 font-light">
                “Right to food, clothing, and shelter”
              </p>
            </div>
          </div>
        </div>
        <div  className="-ml-12 -mt-12 p-12 lg:mt-10 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-full max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={One}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              Based on the life condition of children who have been supported by the foundation, some of the sensitive issues detected are malnutrition, clothing and shelter. From that food and clothing were among the basic needs they have been benefiting. Furthermore, we found that families they are originated from are mostly widows, single mothers, divorced, or vulnerable with no housing. Most of them have been victims of floods that occurred around Lake Tanganyika in the past years and have never been set up into safe lands. One of the current priorities for the foundation is to provide basic needs to these kids; that is a safe place to live, food, and clothing.
              </p>
              <h2 className="mt-4 text-xl font-light tracking-tight text-gray-900">“Give Food to the Hungry”</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-2 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-2">
        <div className="lg:col-span-2 lg:col-start-2 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8  lg:px-8">
          <div className="lg:pr-0">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-sky-600">Core program</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Education Program</h1>
              <p className="mt-6 text-xl leading-8 font-thin text-gray-700">
                “SDG4, Right to Education”
              </p>
            </div>
          </div>
        </div>
        <div className="-mr-12 -mt-12 p-12 lg:mt-10  lg:col-start-1 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-full max-w-none object-left rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={Two}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-2 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              This Program is dedicated to academic education and vocational trainings for children and the youth. Key activities include:
              <ul className="mt-2 space-y-2 text-gray-600">
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Integrate street kids into schools </span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Provide school fee and school materials to enrolled children</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Follow up students’ performance and provide opportunities for capacity building</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Organize team building sessions to promote social cohesion and cultural values for kids and youth</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Implement a vocational training center to promote creativity and job creation among youth</span>
                </li>
              </ul>
              </p>
              <h2 className="mt-4 text-xl font-light tracking-tight text-gray-900"> “Education is one thing no one can take away from you”</h2>
            </div>
          </div>
        </div>
      </div>
        
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-2">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-sky-600">Core program</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Health and Hygiene Program</h1>
              {/* <p className="mt-4 text-xl leading-8 text-gray-700 font-light">
                “Right to food, clothing, and shelter”
              </p> */}
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-10 p-12 lg:mt-1 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-full max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={Three}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              Access to health care is one of the fundamental rights. As the foundation supports vulnerable children, health is an important aspect that couldn’t be left behind. Children need psychological advice for mental health as well as medical care for healthy body. Key activities include:
              <ul className="mt-2 space-y-2 text-gray-600">
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Training on health and hygiene </span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Provide access to basic medical care</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>At least one psychologist and one medical doctor in place to assist kids in needs of health advice</span>
                </li>
              </ul>
              </p>
              {/* <h2 className="mt-4 text-xl font-light tracking-tight text-gray-900">“Give Food to the Hungry”</h2> */}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-2 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-2">
        <div className="lg:col-span-2 lg:col-start-2 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8  lg:px-8">
          <div className="lg:pr-0">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-sky-600">Core program</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Law & Social protection Program</h1>
              {/* <p className="mt-6 text-xl leading-8 font-thin text-gray-700">
                “Right to food, clothing, and shelter”
              </p> */}
            </div>
          </div>
        </div>
        <div className="-mr-12 -mt-12 p-12 lg:mt-4  lg:col-start-1 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-full max-w-none object-right rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={Four}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-2 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              The condition of homelessness limit kids get administrative documents needed to access other rights. Some are not registered and therefore don’t have birth certificates which is a condition to access free health care for children under five years, access free education in fundamental level, and apply for identity card & passport. Main activities that will be covered under this program are:
              <ul className="mt-2 space-y-2 text-gray-600">
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>To ensure that every child is registered and has a birth certificate</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Raise awareness of basic rights </span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Provide legal assistance </span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Ensure every child has a medical insurance</span>
                </li>
              </ul>
              </p>
              {/* <h2 className="mt-4 text-2xl font-light tracking-tight text-gray-900">“Give Food to the Hungry”</h2> */}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-2">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-sky-600">Core program</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Gender Equality and Women's Empowerment Program</h1>
              {/* <p className="mt-4 text-xl leading-8 text-gray-700 font-light">
                “Right to food, clothing, and shelter”
              </p> */}
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-12 p-12 lg:mt-10  lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-full max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-full"
            src={Five}
            alt=""
          />
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-0">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
              <p>
              Destiny focus recognizes the role of mothers in raising a child and providing everyday accompaniment for kids to fulfil their destiny. Moreover, living in a family is a fundamental right; therefore the foundation’s approach in support of vulnerable kids is to integrate them in families and ensure their wellbeing. Gender equality means that the foundation will take into consideration the needs of boys and girls equally, as well as special needs depending of life conditions of beneficiaries. Main activities in the women empowerment program are: 
              <ul className="mt-2 space-y-2 text-gray-600">
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Socio-economic empowerment of mothers of assisted kids</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Business training and financing income generating activities</span>
                </li>
                <li className="flex gap-x-3">
                  <ArrowSmallRightIcon className="mt-1 h-5 w-5 flex-none text-sky-600" aria-hidden="true" />
                  <span>Improving family livelihood and integrate kids in families where wellbeing is guaranteed </span>
                </li>
              </ul>
              </p>
              {/* <h2 className="mt-4 text-xl font-light tracking-tight text-gray-900">“Give Food to the Hungry”</h2> */}
            </div>
          </div>
        </div>
      </div>
      
    </div>
  )
}
